<template>
  <div class="containar">
    <div class="clock-contents-block">
        <div class="">
          <div id="clock" class="clock-preview" v-bind:class="[foreColor, fontStyle]">
            <span class="date" v-bind:class="dateOn">{{ date }}</span>
            <span class="time">{{ time }}</span>
          </div>
        </div>
        <div class="set">
          <h3>日付の有無</h3>
          <div class="toggle-group">
            <label class="toggle-option" :class="{ active: hide === 'on' }">
              <input type="radio" value="on" v-model="hide" />
              <span class="toggle-label">日付あり</span>
            </label>
            <label class="toggle-option" :class="{ active: hide === 'off' }">
              <input type="radio" value="off" v-model="hide" />
              <span class="toggle-label">日付なし</span>
            </label>
          </div>
          <h3>グラデーション選択</h3>
          <div class="gradient-grid">
            <label class="gradient-option" :class="{ active: color === 'green' }">
              <input type="radio" value="green" v-model="color" />
              <div class="gradient-preview green-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'blue' }">
              <input type="radio" value="blue" v-model="color" />
              <div class="gradient-preview blue-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'red' }">
              <input type="radio" value="red" v-model="color" />
              <div class="gradient-preview red-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'sky' }">
              <input type="radio" value="sky" v-model="color" />
              <div class="gradient-preview sky-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'gray' }">
              <input type="radio" value="gray" v-model="color" />
              <div class="gradient-preview gray-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'yellow' }">
              <input type="radio" value="yellow" v-model="color" />
              <div class="gradient-preview yellow-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'lush' }">
              <input type="radio" value="lush" v-model="color" />
              <div class="gradient-preview lush-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'moon' }">
              <input type="radio" value="moon" v-model="color" />
              <div class="gradient-preview moon-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'rose' }">
              <input type="radio" value="rose" v-model="color" />
              <div class="gradient-preview rose-gradient-background"></div>
            </label>
            <label class="gradient-option" :class="{ active: color === 'steel' }">
              <input type="radio" value="steel" v-model="color" />
              <div class="gradient-preview steel-gradient-background"></div>
            </label>
          </div>
          <h3>フォント選択</h3>
          <div class="font-dropdown-container">
            <div class="custom-font-dropdown" :class="{ open: fontDropdownOpen }">
              <div class="dropdown-selected" @click="toggleFontDropdown">
                <span :class="getCurrentFontClass()" class="selected-font-preview">{{ getCurrentFontName() }}</span>
                <span class="dropdown-arrow">▼</span>
              </div>
              <div class="dropdown-options" v-if="fontDropdownOpen">
                <div v-for="font in fontOptions" :key="font.value" 
                     class="dropdown-option" :class="font.class"
                     @click="selectFont(font.value)">
                  <span class="font-preview-text">12:05</span>
                  <span class="font-name-small">{{ font.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <h3>配信ソフト用URL</h3>
          <div class="url-description">
            <p>各項目を選択するとURLが自動的に生成されます。</p>
            <p>OBSならば、ソースの「ブラウザ」を追加→下記URLを入力すると表示できます。</p>
          </div>
          <div class="url-container">
            <input :value="urlInput + '?color=' + color + '&font=' + fontsytle + '&hide=' + hide" 
                   id="target" type="text" readonly class="url-input" />
            <button @click="copy" class="url-copy-btn">
              <span>コピー</span>
            </button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      date: "",
      time: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      hide: "on",
      color: 'green',
      fontsytle:'font0',
      urlInput:'https://ruri.info/tool/clockdesign',
      fontDropdownOpen: false,
      fontOptions: [
        { value: 'font0', name: 'Outfit', class: 'font0' },
        { value: 'font1', name: 'Open Sans', class: 'font1' },
        { value: 'font2', name: 'Iceland', class: 'font2' },
        { value: 'font3', name: 'Single Day', class: 'font3' },
        { value: 'font4', name: 'Klee One', class: 'font4' },
        { value: 'font5', name: 'Tiny5', class: 'font5' }
      ]
    };
  },

  computed: {
    dateOn: function() {
      if (this.hide === 'off') {
        return 'date-off';
      }
      else {
        return '';
      }
    },
    foreColor: function() {
      if (this.color === 'green') {
        return 'green-gradient-background';
      }
      else if (this.color === 'blue') {
        return 'blue-gradient-background';
      }
      else if (this.color === 'red') {
        return 'red-gradient-background';
      }
      else if (this.color === 'sky') {
        return 'sky-gradient-background';
      }
      else if (this.color === 'gray') {
        return 'gray-gradient-background';
      }
      else if (this.color === 'yellow') {
        return 'yellow-gradient-background';
      }
      else if (this.color === 'lush') {
        return 'lush-gradient-background';
      }
      else if (this.color === 'moon') {
        return 'moon-gradient-background';
      }
      else if (this.color === 'rose') {
        return 'rose-gradient-background';
      }
      else if (this.color === 'steel') {
        return 'steel-gradient-background';
      }
      else {
        return '';
      }
    },
    fontStyle: function() {
      if (this.fontsytle === 'font0') {
        return 'font0';
      }
      else if (this.fontsytle === 'font1') {
        return 'font1';
      }
      else if (this.fontsytle === 'font2') {
        return 'font2';
      }
      else if (this.fontsytle === 'font3') {
        return 'font3';
      }
      else if (this.fontsytle === 'font4') {
        return 'font4 font4-manage';
      }
      else if (this.fontsytle === 'font5') {
        return 'font5 font5-manage';
      }
      else {
        return '';
      }
    }
  },
  mounted: function () {
    setInterval(this.updateTime, 1000);
    // ドロップダウン外部クリック時の処理
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    updateTime: function () {
      //現在の日付・時刻を取得
      let currentdate = new Date();

      // 現在の時刻
      this.time =
        this.zeroPadding(currentdate.getHours(), 2) +
        ":" +
        this.zeroPadding(currentdate.getMinutes(), 2);
      // this.zeroPadding(currentdate.getSeconds(), 2);

      // 現在の年月日
      this.date =
        this.zeroPadding(currentdate.getFullYear(), 4) +
        "-" +
        this.zeroPadding(currentdate.getMonth() + 1, 2) +
        "-" +
        this.zeroPadding(currentdate.getDate(), 2) +
        " " +
        this.week[currentdate.getDay()];
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.urlInput + '?color=' + this.color + '&font=' + this.fontsytle + '&hide=' + this.hide)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
    toggleFontDropdown() {
      this.fontDropdownOpen = !this.fontDropdownOpen;
    },
    selectFont(fontValue) {
      this.fontsytle = fontValue;
      this.fontDropdownOpen = false;
    },
    getCurrentFontName() {
      const currentFont = this.fontOptions.find(font => font.value === this.fontsytle);
      return currentFont ? currentFont.name : 'Outfit';
    },
    getCurrentFontClass() {
      const currentFont = this.fontOptions.find(font => font.value === this.fontsytle);
      return currentFont ? currentFont.class : 'font0';
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.custom-font-dropdown');
      if (dropdown && !dropdown.contains(event.target)) {
        this.fontDropdownOpen = false;
      }
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Iceland&family=Open+Sans:wght@500&family=Shadows+Into+Light&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Yuji+Mai&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Klee+One:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Single+Day&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Tiny5&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.containar{
  margin: 0 auto;
  max-width: 767px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}


.clock-contents-block{
  text-align: left;
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	align-items: center;
  margin: 24px auto;
  min-width: 0;
  height: 100%;
}

@media screen and (max-width: 630px) {
  .clock-contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0px!important;
  }
}


#clock {
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 12px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  color: #fff;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  white-space: nowrap;
}


.time {
  letter-spacing: 0.05em;
  font-size: 80px;
  line-height: 0.9em;
}

.date {
  padding-top: 12px;
  letter-spacing: 0.1em;
  font-size: 24px;
  display: block;
}

.set{
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  box-sizing: border-box;
  margin-left: 24px;
}

.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  width: 48px;
  padding: 12px 18px 12px 18px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off{
  display:none;
}

.blue-gradient-background {
  background: linear-gradient(260deg,#FBDA61 0%, #FF5ACD 100%);
  background-size: 180% 180%;
  animation: blue-gradient-animation 10s ease infinite;
}

@keyframes blue-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.red-gradient-background {
  background: linear-gradient(43deg,#4158D0 0%, #C850C0 46%, #FFCC70 100%);
  background-size: 180% 180%;
  animation: red-gradient-animation 6s ease infinite;
}

@keyframes red-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.green-gradient-background {
  background: linear-gradient(256deg,#0093E9 0%,#a1efc6 46%, #80D0C7 100%);
  background-size: 240% 240%;
  animation: green-gradient-animation 10s ease infinite;
}

@keyframes green-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.sky-gradient-background {
  background: linear-gradient(260deg, #D9AFD9 0%, #97D9E1 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

@keyframes sky-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.gray-gradient-background {
  background: linear-gradient(260deg, #304352 0%, #d7d2cc 100%);
  background-size: 240% 240%;
  animation: gray-gradient-animation 12s ease infinite;
}

@keyframes gray-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.yellow-gradient-background {
  background: linear-gradient(260deg, #F3F9A7 0%, #CAC531 100%);
  background-size: 240% 240%;
  animation: yellow-gradient-animation 12s ease infinite;
}

@keyframes yellow-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.lush-gradient-background {
  background: linear-gradient(260deg, #56ab2f 0%, #a8e063 100%);
  background-size: 240% 240%;
  animation: lush-gradient-animation 12s ease infinite;
}

@keyframes lush-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.moon-gradient-background {
  background: linear-gradient(260deg, #4e54c8 0%, #8f94fb 100%);
  background-size: 240% 240%;
  animation: moon-gradient-animation 12s ease infinite;
}

@keyframes moon-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.rose-gradient-background {
  background: linear-gradient(260deg, #f4c4f3 0%, #fc67fa 100%);
  background-size: 240% 240%;
  animation: rose-gradient-animation 12s ease infinite;
}

@keyframes rose-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.steel-gradient-background {
  background: linear-gradient(260deg, #1F1C2C 0%, #928DAB 100%);
  background-size: 240% 240%;
  animation: steel-gradient-animation 12s ease infinite;
}

@keyframes steel-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.font0{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.font1{
  font-family: "Open Sans", sans-serif;
}
.font2{
  font-family: 'Iceland', cursive;
}
.font3{
  font-family: 'Single Day', cursive;
}
.font4{
  font-family: 'Klee One', cursive;
}
.font4-manage{
  padding-bottom: 20px !important;
}
.font5{
  font-family: "Tiny5", serif;
  font-weight: 400;
  font-style: normal;
}
.font5-manage{
  padding-left: 40px !important;
}
.radio-main{
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  margin-top:12px;
  box-sizing: border-box;
}

.m-form-text{
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.copy-btn{
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn:active{
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  border-bottom: none;
}

/* Custom Font Dropdown */
.font-dropdown-container {
  margin-top: 12px;
  position: relative;
}

.custom-font-dropdown {
  position: relative;
  width: 100%;
}

.dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  background: #ffffff;
  cursor: pointer;
  font-size: 14px;
}

.dropdown-selected:hover {
  box-shadow: 0 0 0 1px #999 inset;
}

.custom-font-dropdown.open .dropdown-selected {
  box-shadow: 0 0 0 2px #3182ce;
}

.selected-font-preview {
  flex: 1;
  font-size: 14px;
}

.dropdown-arrow {
  font-size: 12px;
  color: #666;
  transition: transform 0.2s ease;
}

.custom-font-dropdown.open .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #ccc;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 2px;
}

.dropdown-option {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.dropdown-option:last-child {
  border-bottom: none;
}

.dropdown-option:hover {
  background-color: #f8f8f8;
}

.font-preview-text {
  font-size: 18px;
  margin-bottom: 2px;
  letter-spacing: 0.05em;
}

.font-name-small {
  font-size: 11px;
  color: #666;
  font-family: system-ui, -apple-system, sans-serif;
}

/* Toggle Options (日付切り替え) */
.toggle-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 12px;
}

.toggle-option {
  position: relative;
  cursor: pointer;
  padding: 12px 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  transition: all 0.2s ease;
  text-align: center;
  background: #ffffff;
}

.toggle-option:hover {
  box-shadow: 0 0 0 1px #999 inset;
}

.toggle-option.active {
  box-shadow: 0 0 0 2px #3182ce;
  background: #ebf8ff;
}

.toggle-option input {
  display: none;
}

.toggle-label {
  font-size: 14px;
  font-weight: 500;
  color: #4a5568;
}

.toggle-option.active .toggle-label {
  color: #3182ce;
}

/* Gradient Grid (グラデーション選択) */
.gradient-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  margin-top: 12px;
}

.gradient-option {
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.gradient-option:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.gradient-option.active {
  border-color: #0f172a;
  box-shadow: 0 0 0 2px rgba(15, 23, 42, 0.2);
}

.gradient-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.gradient-preview {
  width: 100%;
  height: 32px;
  border-radius: 4px;
  margin: 0;
}

/* URL Section (配信ソフト用URL) */
.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #0f172a;
  transform: translateY(-1px);
}

.url-copy-btn:active {
  transform: translateY(0);
}
</style>
